var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":_vm.$t('Video Call'),"hide-footer":"","centered":"","no-close-on-esc":_vm.preventAccidentalClose,"hide-header-close":_vm.preventAccidentalClose,"no-close-on-backdrop":_vm.preventAccidentalClose},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('call-manage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }